import React from 'react';
import { planLabel as getPlanLabel } from '../utils/planLabels';
import HeaderCompanySearch from './HeaderCompanySearch';

const HeaderNav = ({ user, publicMode = false, planLabel, onLogout, onWorkspace, onOpenHubs, onOpenPlans, onOpenProfile, onOpenAdmin }) => {
  const signedIn = Boolean(user) && !publicMode;
  const canAccessAdmin = signedIn && (
    user.permissions?.includes('admin') ||
    user.email?.toLowerCase() === 'greg@hffinancial.com' ||
    user.plan === 'employee'
  );
  const active = (href) => window.location.pathname.replace(/\/$/, '') === href.replace(/\/$/, '') || (href === '/hubs' && window.location.pathname.startsWith('/hubs/'));
  const link = (label, href, callback) => <a key={href} className={`topbar-admin-link${active(href) ? ' header-nav-active' : ''}`} href={href} aria-label={label === 'Admin' ? 'Open admin console' : undefined} aria-current={active(href) ? 'page' : undefined} onClick={(event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    if (callback) callback();
    else {
      window.history.pushState({}, '', href);
      window.dispatchEvent(new PopStateEvent('popstate'));
      window.scrollTo(0, 0);
    }
  }}>{label}</a>;
  return <>{signedIn && <HeaderCompanySearch />}<nav className="topbar-meta header-nav" aria-label="Main navigation">
    {signedIn && <span className="header-tier">{getPlanLabel(user.plan, planLabel || user.plan_label || (user.plan ? undefined : 'Account'))} plan</span>}
    {signedIn && link('Home', '/', onWorkspace)}
    {!signedIn && link('Preview', '/preview')}
    {link('Hubs', '/hubs', onOpenHubs)}
    {signedIn && link('Profile', '/profile', onOpenProfile)}
    {link('Plans', '/plans', onOpenPlans)}
    {signedIn && link('Help', '/help')}
    {canAccessAdmin && link('Admin', '/admin', onOpenAdmin)}
    {!signedIn && link('Sign in', '/')}
    {signedIn && <button type="button" className="ghost-button header-signout" onClick={onLogout}>Sign out</button>}
  </nav></>;
};

export default HeaderNav;
